import type { PerilTypePremium } from "../../../client/types.gen";

export type RunTerm = PerilTypePremium["run_term"];

/** One modeled cat peril row's term provenance, as the gate reads it. */
export type TermGateRow = {
  /** The term the row's resolved source priced; null when its run predates run identities. */
  runTerm: RunTerm;
  /** True for a stub row whose source produced no result. */
  missingData: boolean;
};

/**
 * Whether the Layers tab splits the modeled loss into TAL (term average loss,
 * what the premium is priced on) and AAL (annual). Only when every modeled cat
 * peril with a result was priced on the policy term: a single older annual run
 * among them would put annual numbers under a "TAL" header.
 */
export const showTermColumns = (rows: TermGateRow[]): boolean => {
  const modeled = rows.filter((row) => !row.missingData);
  return modeled.length > 0 && modeled.every((row) => row.runTerm === "policy");
};
